import React from 'react';

import './styles.scss';
import {createClassName} from '../../util/utility';

interface ColumnProps extends React.HTMLProps<HTMLDivElement> {
  children?: any;
  className?: string;
}

function Column({children, className, ...rest}: ColumnProps) {
  const classes = createClassName('app-column', className);

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export default Column;
